import React from 'react';

const Challenge = () => {
  const questions = [
    "How do we balance AI augmentation with human intuition in decision-making?",
    "What cultural shifts are necessary to integrate AI ethically and effectively?",
    "How do we preserve human connection in an AI-enhanced workplace?",
    "What new leadership competencies emerge in AI-integrated organizations?",
    "How do we ensure equitable access to AI tools across all levels?",
    "What governance frameworks do we need for responsible AI adoption?",
    "How do we measure the ROI of human-AI collaboration?"
  ];

  return (
    <section className="py-[100px] bg-[#F5F5F0] opacity-0 animate-fadeIn-delayed-1">
      <div className="w-[90%] max-w-[1200px] mx-auto px-5">
        <blockquote className="max-w-[900px] mx-auto mb-[50px] p-10 border-l-4 border-[#6B4DC4] italic text-[1.4rem] leading-[1.7] text-[#333333] bg-white shadow-[0_4px_20px_rgba(0,0,0,0.1)]">
          <p className="mb-0">
            "As artificial intelligence becomes increasingly embedded in our organizations, we stand at a critical juncture. 
            The choices we make today about integrating AI into our workplace culture will define how effectively we harness 
            its potential while preserving the human elements that drive innovation, collaboration, and authentic leadership."
          </p>
        </blockquote>
        
        <div className="max-w-[800px] mx-auto">
          <h3 className="text-center mb-[30px] text-[1.5rem] text-[#6B4DC4] font-heading font-semibold">
            Key Questions We'll Explore:
          </h3>
          <ul className="list-none [counter-reset:question-counter]">
            {questions.map((question, index) => (
              <li 
                key={index}
                className="relative pl-[60px] mb-[25px] text-[1.2rem] pt-[10px] pb-[10px] border-b border-[rgba(107,77,196,0.2)] before:content-[counter(question-counter)] before:[counter-increment:question-counter] before:absolute before:left-0 before:top-[10px] before:w-10 before:h-10 before:bg-gradient-to-br before:from-[#6B4DC4] before:to-[#4ECDC4] before:text-white before:rounded-full before:flex before:items-center before:justify-center before:font-bold before:font-heading"
              >
                {question}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Challenge;

